export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/handoutsFill.fa227073.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};